import { render, staticRenderFns } from "./edit-connection-business-profile-form.vue?vue&type=template&id=406efb4b&"
import script from "./edit-connection-business-profile-form.vue?vue&type=script&lang=js&"
export * from "./edit-connection-business-profile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports